var BarrasHorizontalesPorcentajesCortas = function(el, datos, total, callback) {
  var debug = false;

  var altoVisualizacion = 0;

  var medidasAux = {
    top: 80,
    right: 10,
    bottom: 60,
    left: 300
  };

  (function() {
    datos.opciones = _.filter(datos.opciones, function(d) {
      return d.valor > 0;
    });
    var config = new Config(0, medidasAux);
    var estilos = config.getEstilos();
    var contenedor = d3.select(el[0]);
    var flag = el.data("visualizacion") || false;
    if (flag === false) {
      var barras = config.getBarrasHorizontales();
      var svg = contenedor
        .append("svg")
        .attr("preserveAspectRatio", "xMidYMid")
        .attr("viewBox", "0 0 " + config.getAncho() + " " + 0);
      var texto = svg
        .append("text")
        .style(estilos.valoresBarraHorizontal)
        .text("A");
      var caja = texto.node().getBBox();
      //console.log(datos.titulo);
      //console.log(caja.height);
      //console.log(datos.opciones.length);
      altoVisualizacion =
        (caja.height + barras.distanciaVertical) * datos.opciones.length;
      //console.log(altoVisualizacion);
      var margin = config.getMargin();
      var gMargin = config.getGMargin();
      altoVisualizacion +=
        margin.top + margin.bottom + gMargin.top + gMargin.bottom;
      svg.remove();
    }
  })();

  var config = new Config(altoVisualizacion, medidasAux);

  var margin = config.getMargin();
  var medidas = config.getMedidas();

  var gMargin = config.getGMargin();
  var gMedidas = config.getGMedidas();

  var estilos = config.getEstilos();

  var contenedor = null;
  var svg = null;
  var gGrafica = null;
  var gReticula = null;
  var gEjeX = null;
  var gEjeY = null;
  var gBarras = null;
  var gLeyendas = null;

  var multiplicadorX = 3 / 5;

  var escalaX = d3.scale.linear().range([0, gMedidas.ancho * multiplicadorX]);
  var escalaY = d3.scale.ordinal().rangeRoundBands([gMedidas.alto, 0], 0.5);
  var escalaOpacidad = d3.scale.linear().range([0.3, 1]);

  var ejeX = d3.svg
    .axis()
    .scale(escalaX)
    .orient("bottom")
    .ticks(5)
    .tickFormat(function(d) {
      return d + "%";
    });

  var ejeY = d3.svg
    .axis()
    .scale(escalaY)
    .orient("left")
    .tickFormat(function(d) {
      var obj = _.find(datos.opciones, { opcion: d }) || false;
      return obj === false ? d : obj.etiqueta;
    });

  function setup() {
    contenedor = d3.select(el[0]);
    var flag = el.data("visualizacion") || false;
    if (flag === false) {
      el.data("visualizacion", true);
      contenedor.selectAll("svg").remove();
      svg = contenedor
        .append("svg")
        .attr("preserveAspectRatio", "xMidYMid")
        .attr(
          "viewBox",
          "0 0 " +
            (medidas.ancho + margin.left + margin.right) +
            " " +
            (medidas.alto + margin.top + margin.bottom)
        );

      el.attr("data-setup", true);

      if (debug === true) {
        svg
          .append("rect")
          .attr("fill", "yellow")
          .attr("opacity", 0.5)
          .attr("x", 0)
          .attr("y", 0)
          .attr("width", medidas.ancho + margin.left + margin.right)
          .attr("height", medidas.alto + margin.top + margin.bottom);
      }

      svg = svg
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      if (debug === true) {
        svg
          .attr("class", "svg")
          .append("rect")
          .attr("width", medidas.ancho + (margin.right - margin.left))
          .attr("height", medidas.alto)
          .attr("fill", "blue")
          .attr("opacity", 0.5);
      }

      gGrafica = svg
        .append("g")
        .attr(
          "transform",
          "translate(" + gMargin.left + "," + gMargin.top + ")"
        );

      if (debug === true) {
        gGrafica
          .attr("class", "gGrafica")
          .append("rect")
          .attr("width", gMedidas.ancho)
          .attr("height", gMedidas.alto)
          .attr("fill", "red")
          .attr("opacity", 0.5);
      }

      gReticula = gGrafica.append("g");
      gEjeX = gGrafica
        .append("g")
        .attr("class", "x axis")
        .attr("transform", "translate(0," + gMedidas.alto + ")");
      gEjeY = gGrafica.append("g").attr("class", "y axis");
      gBarras = gGrafica.append("g");
      gLeyendas = gGrafica.append("g");

      datos.opciones = _.filter(datos.opciones, function(d) {
        return d.valor !== 0;
      });

      total = _.sumBy(datos.opciones, "valor");
      var pcts = funciones.getPorcentajes(
        _.map(datos.opciones, "valor"),
        total
      );
      _.each(pcts, function(p, i) {
        datos.opciones[i].valor = pcts[i];
      });

      var orden = el.data("orden") || false;
      if (orden !== false) {
        orden = orden.toLowerCase();
        switch (orden) {
          case "alfa":
            datos.opciones.sort(ordenAlfabetico);
            break;
          case "inverso":
            datos.opciones.reverse();
            break;
          default:
            break;
        }
      }
      main();
    }
  }

  function main() {
    setEscalas();
    setEjes();
    setLeyendas();
    funciones.generaTooltips(gGrafica.selectAll("path.transporte"));
    el.removeClass("espera");
    iniciar();
  }

  function revisaScroll() {
    if (el.visible(true) === true) {
      iniciar();
      $(window).off("scroll", revisaScroll);
    }
  }

  function iniciar() {
    actualizaBarras();
    callback(null, true);
  }

  function setEscalas() {
    escalaX.domain([0, 100]);
    escalaY.domain(
      datos.opciones.map(function(d) {
        return d.opcion;
      })
    );
    escalaOpacidad.domain([0, 100]);
  }

  function setEjes() {
    gEjeY
      .style(estilos.eje)
      .call(ejeY)
      .selectAll("text")
      .style(estilos.etiquetaEjeY);

    var flagEjeX = el.data("eje-x") || false;
    if (flagEjeX !== false) {
      gEjeX
        .style(estilos.eje)
        .call(ejeX)
        .selectAll("text")
        .style(estilos.etiquetaEjeX);

      gEjeX
        .selectAll("line")
        .style(estilos.reticula)
        .attr("x1", 0)
        .attr("x2", 0)
        .attr("y1", 0)
        .attr("y2", -gMedidas.alto);
    } else {
      gEjeX
        .append("line")
        .style(estilos.reticula)
        .attr("x1", 0)
        .attr("x2", 0)
        .attr("y1", 0)
        .attr("y2", -gMedidas.alto);
    }
  }

  function actualizaBarras() {
    var barras = gBarras.selectAll("rect").data(datos.opciones, function(d) {
      return d.opcion;
    });
    var valores = gBarras.selectAll("text").data(datos.opciones, function(d) {
      return d.opcion;
    });

    barras
      .enter()
      .append("rect")
      .style(estilos.barra)
      .attr("opacity", function(d) {
        return escalaOpacidad(d.valor);
      })
      .attr("y", function(d) {
        return escalaY(d.opcion);
      })
      .attr("x", 0)
      .attr("height", escalaY.rangeBand())
      .attr("width", 0)
      .transition()
      .duration(800)
      .attr("width", function(d) {
        return escalaX(d.valor);
      });

    valores
      .enter()
      .append("text")
      .text(function(d) {
        var v = parseInt(d.valor);
        if (v === 0) {
          v = "<1";
        }
        return v + "%";
      })
      .style(estilos.valoresBarraHorizontal)
      .attr("y", function(d) {
        return escalaY(d.opcion) + escalaY.rangeBand() / 2;
      })
      .attr("x", 6)
      .transition()
      .duration(800)
      .attr("x", function(d) {
        return escalaX(d.valor) + 6;
      });
  }

  function setLeyendas() {
    var titulo = datos.titulo || false;
    if (titulo !== false) {
      svg
        .append("text")
        .style(estilos.titulo)
        .attr("x", 0)
        .attr("y", margin.top)
        .text(titulo);
    }
    var leyendaX = el.data("leyenda-x") || false;
    if (leyendaX !== false) {
      svg
        .append("text")
        .style(estilos.leyendaEjeX)
        .attr("x", gMargin.left + 20)
        .attr("y", medidas.alto - 12)
        .text(leyendaX);
    }
    var leyendaY = el.data("leyenda-y") || false;
    if (leyendaY !== false) {
      var x = margin.left;
      var y = gMargin.top - 8;
      svg
        .append("text")
        .style(estilos.leyendaEjeY)
        .attr("x", x)
        .attr("y", y)
        .attr("transform", "rotate(-90," + x + "," + y + ")")
        .text(leyendaY);
    }
    var unidadPromedio = el.data("unidad-promedio") || false;
    if (unidadPromedio !== false) {
      var y = gMargin.top - 8;
      var suma = _.sumBy(datos.opciones, function(d) {
        return d.opcion * d.valor;
      });
      var promedio = parseInt(suma / +total);
      var textoUnidad = svg
        .append("text")
        .style(estilos.leyendaPromedioUnidad)
        .attr("x", medidas.ancho - gMargin.right)
        .attr("y", 12)
        .text(promedio + " " + unidadPromedio);
      var cajaTextoUnidad = textoUnidad.node().getBBox();
      svg
        .append("text")
        .style(estilos.leyendaPromedio)
        .attr("x", medidas.ancho - (gMargin.right + 20 + cajaTextoUnidad.width))
        .attr("y", 12)
        .text("Promedio: ");
    }
  }

  function ordenAlfabetico(a, b) {
    var aTxt = a.etiqueta.toUpperCase();
    var bTxt = b.etiqueta.toUpperCase();
    if (aTxt < bTxt) {
      return 1;
    }
    if (aTxt > bTxt) {
      return -1;
    }
    return 0;
  }

  setup();
};
